"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "@/app/features/slices/authSlice";
// import { Button } from "bootstrap/dist/js/bootstrap.bundle.min";
import { useRouter } from "next/navigation";
import main_logo from "../../../../public/images/logo.png";
import { Button, Offcanvas } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import {
  getUserDetailsThunk,
  updateProfileThunk,
} from "@/app/features/thunks/userThunk";
import { ScaleLoader } from "react-spinners";
import { persistor } from "../../../../store/store";
import Loader from "@/components/Loader";
import AddressModal from "@/components/modals/AddressModal";
import {
  deleteNotificationThunk,
  getNotificationListThunk,
  markAsReadThunk,
} from "@/app/features/thunks/notificationThunk";
import { getOrderDetailsThunk } from "@/app/features/thunks/orderThunk";
import OrderDetailsModal from "@/components/modals/OrderDetailsModal";
import eventTracker from "../../../../utils/analytics";
import EVENT_NAMES from "../../../../utils/eventNames";
function Page() {
  const dispatch = useDispatch();
  const router = useRouter();
  const [loading, setLoading] = useState(true);
  const userDetails = useSelector((store) => store?.user?.userDetails);
  const token = useSelector((store) => store?.auth?.user?.accessToken);
  const notificationList = useSelector(
    (store) => store?.notification?.notificationList
  );

  // const user = useSelector((store) => store?.auth?.user?.user);
  const [show, setShow] = useState(false);
  const [orderDetailsModalShow, setOrderDetailsModalShow] = useState(false);
  const [showCopyPopup, setShowCopyPopup] = useState(false);
  const [copyReferralCode, setCopyReferralCode] = useState(false);
  const [copyReferralUrl, setCopyReferralUrl] = useState(false);
  const [locationError, setLocationError] = useState("");

  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      // setLocation({
      //   latitude: null,
      //   longitude: null,
      //   error: "Geolocation not supported",
      // });
      return;
    }

    setLocationError("");
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        // setLocation({
        //   latitude: position.coords.latitude?.toString(),
        //   longitude: position.coords.longitude?.toString(),
        // });
      },
      (error) => {
        setLocationError(
          "Location access is currently disabled. To ensure accurate results, please enable location permissions in your browser settings."
        );
        return;
        // setLocation({ latitude: null, longitude: null, error: error.message });
      }
    );
  };

  useEffect(() => {
    getNotifications();
    handleGetLocation();
    // setTimeout(() => {
    // setLoading(false);
    // }, 1000);
  }, [token]);

  const getNotifications = async () => {
    await dispatch(getNotificationListThunk({ token }));
    setLoading(false);
  };

  const handleLogout = async () => {
    eventTracker.track(EVENT_NAMES.LOGOUT_SUCCESS, {
      userId: userDetails?.id,
      email: userDetails?.email,
    });
    await dispatch(logout());
    router.replace("/");
  };

  const [toggleNotification, setShowNotification] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [showReferEarn, setShowReferEarn] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleShowNotification = () => setShowNotification((prev) => !prev);
  const handleCloseNotification = () => setShowNotification(false);
  const toggleProfile = () => setShowProfile((prev) => !prev);
  const toggleEditProfile = () => setShowEditProfile((prev) => !prev);
  const toggleReferEarn = () => setShowReferEarn((prev) => !prev);
  const [showHelpSupport, setShowHelpSupport] = useState(false);
  const toggleHelpSupport = () => setShowHelpSupport((prev) => !prev);
  // const handleBack = () => {
  //   window.history.back();
  // };

  const updateProfileFormik = useFormik({
    initialValues: {
      first_name: userDetails?.first_name || "",
      last_name: userDetails?.last_name || "",
      profile_picture: userDetails?.profile_picture || "",
      // email: user?.email || '',
      // phone_number: user?.phone_number || ''
    },
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("first_name", values.first_name);
      formData.append("last_name", values.last_name);
      if (values.profile_picture instanceof File) {
        formData.append("profile_picture", values.profile_picture);
      }
      await dispatch(updateProfileThunk({ token, data: formData }));

      await dispatch(getUserDetailsThunk({ token }));
    },
  });

  const timeAgo = (timestamp) => {
    const now = new Date();
    const past = new Date(timestamp);
    const seconds = Math.floor((now - past) / 1000);

    const intervals = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60,
    };

    for (const [unit, value] of Object.entries(intervals)) {
      const count = Math.floor(seconds / value);
      if (count >= 1) {
        return `${count} ${unit}${count > 1 ? "s" : ""} ago`;
      }
    }

    return "Recent";
  };

  const handleDeleteNotification = async (notificationId) => {
    await dispatch(deleteNotificationThunk({ token, notificationId }));
    await dispatch(getNotificationListThunk({ token }));
  };

  const isRecentNotification = (updatedAt) => {
    const now = new Date();
    const updatedTime = new Date(updatedAt);
    const diffInMs = now - updatedTime;
    const diffInHours = diffInMs / (1000 * 60 * 60);
    return diffInHours < 24;
  };

  const handleCopyReffralCode = async () => {
    if (typeof window !== "undefined" && navigator?.clipboard) {
      try {
        await navigator.clipboard.writeText(userDetails?.referral_code);
        setCopyReferralCode(true);
        setTimeout(() => setCopyReferralCode(false), 1500);
      } catch (err) {
        console.error(err);
        // setCopyReferralCode(');
      }
    } else {
      // setCopyReferralCode('Clipboard not supported!');
    }
  };

  const handleShareRefferalUrl = async (platform, url) => {
    let shareUrl = "";

    const encodedUrl = encodeURIComponent(url);

    switch (platform) {
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;

      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}`;
        break;

      case "linkedin":
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
        break;
      case "whatsapp":
        shareUrl = `https://wa.me/?text=${encodeURIComponent(`${url}`)}`;
        break;
      case "copy":
        try {
          await navigator.clipboard.writeText(url);
          setCopyReferralUrl(true);
          setTimeout(() => setCopyReferralUrl(false), 1500);
        } catch (err) {
          console.error("Copy failed", err);
        }
        return;
        break;
      default:
        return;
    }

    window.open(shareUrl, "_blank");
  };
  const handleViewNotification = async (
    notificationId,
    notificationType,
    orderId
  ) => {
    await dispatch(
      markAsReadThunk({ token, data: { notification_id: notificationId } })
    );
    if (notificationType == "order") {
      await dispatch(getOrderDetailsThunk({ token, orderId }));
      setOrderDetailsModalShow(true);
    }
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        // <></>
        <div>
          <header className="homepage-header fixed-top">
            {locationError && (
              <div
                className="alert alert-danger text-center m-0"
                role="alert"
                style={{ borderRadius: "0" }}
              >
                Location access is currently disabled. To ensure accurate
                results, please enable location permissions in your browser
                settings.
              </div>
            )}

            <nav className="navbar navbar-expand-lg py-0">
              <div className="container">
                <Link href="/" className="navbar-brand">
                  <Image
                    src={main_logo}
                    alt="Logo"
                    width={100}
                    height={100}
                    className="img-fluid main-header-logo"
                  />
                </Link>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#customerNavbar"
                  aria-controls="customerNavbar"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div
                  className="collapse navbar-collapse align-items-center onmobile-head"
                  id="customerNavbar"
                >
                  <form role="search" className="customer-address-width">
                    <div className="d-flex">
                      <Link href="#" className="customer-location-icon">
                        <Image
                          src="/images/location.svg"
                          alt="search icon"
                          className="searchicon img-fluid"
                          width={18}
                          height={18}
                        />
                      </Link>
                      <div className="ms-2 ms-md-3">
                        <p className="customer-header-address mb-0">Address</p>
                        <div className="d-flex align-items-center">
                          <h4 className="customer-address-txt mb-0">
                            {userDetails?.user_addresses?.length > 0
                              ? userDetails?.user_addresses?.[0]?.address
                              : "No data found"}
                          </h4>
                          <button
                            type="button"
                            className="change-address text-decoration-none ms-2"
                            onClick={() => setShow(true)}
                          >
                            {userDetails?.user_addresses?.length > 0
                              ? "Change"
                              : "Select Address"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div className="d-flex my-3 my-md-3 my-lg-0 ms-auto align-items-center">
                    <Link href={"/message"} className="d-inline-flex me-3">
                      <img
                        src="/images/message-icon.svg"
                        alt="message"
                        className="img-fluid"
                      />
                    </Link>
                    <div className="position-relative">
                      <img
                        src="/images/notification-icon.svg"
                        alt="notification"
                        className="img-fluid me-3"
                        style={{ cursor: "pointer" }}
                        onClick={handleShowNotification}
                      />
                      <span className="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-danger">
                        {notificationList?.pagination?.totalItems}
                      </span>
                    </div>
                    <div
                      className="profile-container"
                      onClick={toggleProfile}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={
                          userDetails?.profile_picture
                            ? userDetails?.profile_picture
                            : "/images/no_profile.jpeg"
                        }
                        alt="Profile"
                        className="profile-img"
                      />
                      <p className="profile-name mb-0">
                        {userDetails?.first_name} {userDetails?.last_name}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </header>
          {/* Notification Offcanvas  */}
          <Offcanvas
            show={toggleNotification}
            onHide={handleCloseNotification}
            placement="end"
            scroll={true}
            backdrop={false}
            className="offcanvas-main border-0"
          >
            <Offcanvas.Header className="notification-header" closeButton>
              <Offcanvas.Title className="title-head">
                Notification
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              {notificationList?.notifications ? (
                notificationList?.notifications?.map((notification, index) => (
                  <div
                    className={`notification-content mb-3 cursor-pointer ${
                      isRecentNotification(notification?.updated_at)
                        ? "notification-active-content"
                        : ""
                    }`}
                    key={index}
                    onClick={() =>
                      handleViewNotification(
                        notification?.id,
                        notification?.notification_type,
                        notification?.key
                      )
                    }
                  >
                    <div className="d-flex justify-content-between">
                      <h5>{notification?.data?.title}</h5>
                      <div className="d-flex justify-content-end align-items-center">
                        <p className="mb-0 recent-text">
                          {timeAgo(notification?.updated_at)}
                        </p>
                        <button
                          className="btn border-0 py-0"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteNotification(notification?.id);
                          }}
                        >
                          <img
                            src="/images/trash-solid.svg"
                            className="delete-icon"
                          />
                        </button>
                      </div>
                    </div>
                    <p className="mb-0 order-done-text">
                      {notification?.data?.body}
                    </p>
                  </div>
                ))
              ) : (
                <div className="notification-content d-flex justify-content-center align-items-center mb-3">
                  <div className="d-flex align-items-center">
                    <p className="mb-0 order-done-text">
                      Notification not available
                    </p>
                  </div>
                </div>
              )}
            </Offcanvas.Body>
          </Offcanvas>

          {/* My Profile Offcanvas  */}
          <Offcanvas
            show={showProfile}
            onHide={toggleProfile}
            placement="end"
            scroll={true}
            backdrop={false}
            className="offcanvas-main border-0"
          >
            <Offcanvas.Header closeButton className="notification-header">
              <Offcanvas.Title className="title-head">
                My Profile
              </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body className="d-flex flex-column justify-content-between p-0">
              {/* Profile Content */}
              <div className="profile-info mb-3">
                <img
                  src={
                    userDetails?.profile_picture
                      ? userDetails?.profile_picture
                      : "/images/avtar.png"
                  }
                  alt="avtar"
                  className="img-fluid profile-avtar"
                />
                <h5 className="myprofile-name">
                  {userDetails?.first_name} {userDetails?.last_name}
                </h5>
                <p className="profile-email">{userDetails?.email}</p>
              </div>
              <div className="px-4">
                {/* <!-- Orders Section --> */}
                <div className="mb-4">
                  <h6 className="profile-list-name text-dark mb-2">Orders</h6>
                  <Link
                    href="/booking"
                    className="text-decoration-none text-dark"
                  >
                    <div className="bg-light rounded px-2 py-2 d-flex justify-content-between align-items-center mb-2 pointer">
                      <span className="list-text">Your Orders</span>
                      <img
                        src="/images/right-arrow.svg"
                        alt="arrow"
                        className="img-fluid"
                      />
                    </div>
                  </Link>
                </div>
                {/* <!-- Enquiry Section --> */}
                <div className="mb-4">
                  <h6 className="profile-list-name text-dark mb-2">Enquiry</h6>
                  <Link
                    href="/enquiry"
                    className="text-decoration-none text-dark"
                  >
                    <div className="bg-light rounded px-2 py-2 d-flex justify-content-between align-items-center mb-2 pointer">
                      <span className="list-text">Enquiry</span>
                      <img
                        src="/images/right-arrow.svg"
                        alt="arrow"
                        className="img-fluid"
                      />
                    </div>
                  </Link>
                </div>

                {/* <!-- Transaction Section --> */}
                <div className="mb-4">
                  <h6 className="profile-list-name text-dark mb-2">
                    Transactions
                  </h6>
                  <Link
                    href="/multiple-order"
                    className="text-decoration-none text-dark"
                  >
                    <div className="bg-light rounded px-2 py-2 d-flex justify-content-between align-items-center mb-2 pointer">
                      <span className="list-text">Transactions History</span>
                      <img
                        src="/images/right-arrow.svg"
                        alt="arrow"
                        className="img-fluid"
                      />
                    </div>
                  </Link>
                </div>
                {/* <!-- Favorites List --> */}
                <div className="mb-4">
                  <h6 className="profile-list-name text-dark mb-2">
                    Favorites List
                  </h6>
                  <Link
                    href="/favourite"
                    className="text-decoration-none text-dark"
                  >
                    <div className="bg-light rounded px-2 py-2 d-flex justify-content-between align-items-center mb-2 pointer">
                      <span className="list-text">Favourites</span>
                      <img
                        src="/images/right-arrow.svg"
                        alt="arrow"
                        className="img-fluid"
                      />
                    </div>
                  </Link>
                </div>

                {/* <!-- Account Preference --> */}
                <div className="mb-4">
                  <h6 className="profile-list-name text-dark mb-2">
                    Account Preference
                  </h6>
                  <div
                    className="bg-light rounded px-2 py-2 d-flex justify-content-between align-items-center mb-2 pointer"
                    onClick={toggleEditProfile}
                  >
                    <span className="list-text">Edit Profile</span>
                    <img
                      src="/images/right-arrow.svg"
                      alt="arrow"
                      className="img-fluid"
                    />
                  </div>
                </div>

                {/* <!-- Others Section --> */}
                <div className="mb-4">
                  <h6 className="profile-list-name text-dark mb-2">Others</h6>
                  <Link
                    href="/about-us"
                    className="text-decoration-none text-dark"
                  >
                    <div className="bg-light rounded px-2 py-2 d-flex justify-content-between align-items-center mb-2 pointer">
                      <span className="list-text">About Us</span>
                      <img
                        src="/images/right-arrow.svg"
                        alt="arrow"
                        className="img-fluid"
                      />
                    </div>
                  </Link>
                  <div
                    className="bg-light rounded px-2 py-2 d-flex justify-content-between align-items-center mb-2 pointer"
                    onClick={toggleReferEarn}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="list-text">Refer & Earn</span>
                    <img
                      src="/images/right-arrow.svg"
                      alt="arrow"
                      className="img-fluid"
                    />
                  </div>
                  <div
                    className="bg-light rounded px-2 py-2 d-flex justify-content-between align-items-center mb-2 pointer"
                    onClick={toggleHelpSupport}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="list-text">Help & Support</span>
                    <img
                      src="/images/right-arrow.svg"
                      alt="arrow"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="p-3">
                <button
                  className="logout-button w-100 border-0"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            </Offcanvas.Body>
          </Offcanvas>

          {/* Edit Profile Offcanvas  */}
          <Offcanvas
            show={showEditProfile}
            onHide={toggleEditProfile}
            placement="end"
            scroll={true}
            backdrop={false}
            className="offcanvas-main border-0"
          >
            <Offcanvas.Header
              closeButton
              className="edit-profile-header d-flex justify-content-between"
            >
              <Button
                className="border-0 bg-white text-dark"
                onClick={toggleEditProfile}
              >
                <svg
                  width="6"
                  height="11"
                  viewBox="0 0 6 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.99997 1.5C4.99997 1.5 1 4.44593 1 5.5C1 6.55413 5 9.5 5 9.5"
                    stroke="#525252"
                    strokeWidth="1.1875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="ms-2"> Back</span>
              </Button>
              <Offcanvas.Title className="title-head">
                Edit Profile
              </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body className="d-flex flex-column h-100">
              <div className="flex-grow-1 overflow-auto">
                <div className="profile-info mb-3">
                  <label htmlFor="updateProfile">
                    <img
                      src={
                        previewUrl
                          ? previewUrl
                          : updateProfileFormik.values?.profile_picture
                          ? updateProfileFormik?.values?.profile_picture
                          : "/images/avtar.png"
                      }
                      alt="avtar"
                      className="img-fluid profile-avtar"
                    />
                  </label>
                  <input
                    type="file"
                    className="d-none"
                    accept="image/*"
                    id="updateProfile"
                    onChange={(event) => {
                      const file = event.currentTarget.files?.[0];
                      setPreviewUrl(URL.createObjectURL(file));
                      updateProfileFormik.setFieldValue(
                        "profile_picture",
                        file
                      );
                    }}
                  />
                </div>

                <form onSubmit={updateProfileFormik?.handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label edit-label">First Name</label>
                    <input
                      type="text"
                      name="first_name"
                      className="form-control edit-profile-input"
                      value={updateProfileFormik?.values?.first_name}
                      onChange={updateProfileFormik?.handleChange}
                      onBlur={updateProfileFormik?.handleBlur}
                      placeholder="Johnny"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label edit-label">Last Name</label>
                    <input
                      type="text"
                      name="last_name"
                      value={updateProfileFormik?.values?.last_name}
                      onChange={updateProfileFormik?.handleChange}
                      onBlur={updateProfileFormik?.handleBlur}
                      className="form-control edit-profile-input"
                      placeholder="Smith"
                    />
                    {/* </div> */}
                    {/* <div className="mb-3">
                <label className="form-label edit-label">Email</label>
                <input
                  type="email"
                  name="email"
                  value={updateProfileFormik?.values?.email}
                  onChange={updateProfileFormik?.handleChange}
                  onBlur={updateProfileFormik?.handleBlur}
                  className="form-control edit-profile-input"
                  placeholder="johnnysmith@yopmail.com"
                />
              </div>
              <div className="mb-3">
                <label className="form-label edit-label">Phone</label>
                <input
                  type="number"
                  name="phone_number"
                  value={updateProfileFormik?.values?.phone_number}
                  onChange={updateProfileFormik?.handleChange}
                  onBlur={updateProfileFormik?.handleBlur}
                  className="form-control edit-profile-input"
                  placeholder="+1 (000) 000-0000"
                />
              </div> */}
                    {/* <div className="mb-3">
                      <button className="w-100 delete-account-btn">
                        Delete Account
                      </button>
                    </div> */}
                  </div>
                  {/* Footer */}
                  <div className="mb-3">
                    <button
                      type="submit"
                      className="w-100 border-0 save-button"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </Offcanvas.Body>
          </Offcanvas>

          {/* Refer & Earn Offcanvas  */}
          <Offcanvas
            show={showReferEarn}
            onHide={toggleReferEarn}
            placement="end"
            scroll={true}
            backdrop={false}
            className="offcanvas-main border-0"
          >
            <Offcanvas.Header
              closeButton
              className="edit-profile-header d-flex justify-content-between"
            >
              <Button
                className="border-0 bg-white text-dark"
                onClick={toggleReferEarn}
              >
                <svg
                  width="6"
                  height="11"
                  viewBox="0 0 6 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.99997 1.5C4.99997 1.5 1 4.44593 1 5.5C1 6.55413 5 9.5 5 9.5"
                    stroke="#525252"
                    strokeWidth="1.1875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="ms-2"> Back</span>
              </Button>
              <Offcanvas.Title className="title-head">
                Refer & Earn
              </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body className="d-flex flex-column h-100">
              <div className="flex-grow-1 overflow-auto">
                <div className="mb-3">
                  <img src="/images/frnd.png" alt="" className="img-fluid" />
                  <h4 className="earn-head text-center">
                    Invite your friends and unlock exclusive rewards!
                  </h4>
                </div>
                <h4 className="earn-head">Why Refer?</h4>
                <ul className="why-refer-points">
                  <li className="mb-2">
                    Earn Credits: Get bonus credits for every successful
                    referral.
                  </li>
                  <li className="mb-2">
                    Unlock Special Perks: Early access to features, discounts,
                    and more.
                  </li>
                  <li className="mb-2">
                    Help Friends: Share a platform you love with the people you
                    care about.
                  </li>
                </ul>
                <h4 className="earn-head">How It Works</h4>
                <ol className="list-group list-group-numbered why-refer-points">
                  <li className="list-group-item border-0">
                    Share your referral code with friends.
                  </li>
                  <li className="list-group-item border-0">
                    They sign up and complete their first booking.
                  </li>
                  <li className="list-group-item border-0">
                    You both earn rewards instantly!
                  </li>
                </ol>
                <div className="ref-code d-flex justify-content-between position-relative">
                  <span className="d-inline-block">
                    {userDetails?.referral_code}
                  </span>
                  <span
                    className="cursor-pointer"
                    onClick={handleCopyReffralCode}
                  >
                    {/* <span style={{ marginLeft: '10px', color: 'green' }}>{copyReferralCode}</span> */}
                    {copyReferralCode && (
                      <div
                        className="position-absolute translate-middle-x bg-dark text-white small px-2 py-1 rounded shadow"
                        style={{ top: "-30px", left: "90%" }}
                      >
                        Copied!
                      </div>
                    )}
                    <svg
                      width="22"
                      height="24"
                      viewBox="0 0 22 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.5781 24H4.625C2.55719 24 0.875 22.3178 0.875 20.25V7.54688C0.875 5.47906 2.55719 3.79688 4.625 3.79688H13.5781C15.6459 3.79688 17.3281 5.47906 17.3281 7.54688V20.25C17.3281 22.3178 15.6459 24 13.5781 24ZM4.625 5.67188C3.59119 5.67188 2.75 6.51306 2.75 7.54688V20.25C2.75 21.2838 3.59119 22.125 4.625 22.125H13.5781C14.6119 22.125 15.4531 21.2838 15.4531 20.25V7.54688C15.4531 6.51306 14.6119 5.67188 13.5781 5.67188H4.625ZM21.0781 17.9062V3.75C21.0781 1.68219 19.3959 0 17.3281 0H6.92188C6.40405 0 5.98438 0.419678 5.98438 0.9375C5.98438 1.45532 6.40405 1.875 6.92188 1.875H17.3281C18.3619 1.875 19.2031 2.71619 19.2031 3.75V17.9062C19.2031 18.4241 19.6228 18.8438 20.1406 18.8438C20.6584 18.8438 21.0781 18.4241 21.0781 17.9062Z"
                        fill="#FFAC5A"
                      />
                    </svg>
                  </span>
                </div>
              </div>
              {/* Footer */}
              <div className="position-relative referral">
                {showCopyPopup && (
                  <div
                    className="position-absolute rounded shadow-md referral-popup-icon"
                    style={{ backgroundColor: "#031e60" }}
                  >
                    <div className="modal-dialog share-popup">
                      <div className="modal-content share-popup-spacing">
                        <div className="modal-body p-1 text-center d-flex">
                          <button
                            className="btn refer-share-icons p-0"
                            onClick={() =>
                              handleShareRefferalUrl(
                                "facebook",
                                `${process.env.NEXT_PUBLIC_FRONTEND_URL}/??ref=${userDetails?.referral_code}`
                              )
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="40"
                              height="40"
                              viewBox="0 0 48 48"
                            >
                              <path
                                fill="#FFF"
                                d="M26.5 24h3.5l.5-4h-4v-2.3c0-1 .3-1.7 1.8-1.7h2.2v-3.7c-.4 0-1.6-.2-3.1-.2-3.1 0-5.2 1.9-5.2 5.3V20h-3.5v4h3.5v10h4v-10z"
                              />
                            </svg>
                          </button>

                          <button
                            className="btn refer-share-icons p-0"
                            onClick={() =>
                              handleShareRefferalUrl(
                                "twitter",
                                `${process.env.NEXT_PUBLIC_FRONTEND_URL}/?ref=${userDetails?.referral_code}`
                              )
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="36"
                              height="36"
                              viewBox="0 0 48 48"
                            >
                              <path
                                fill="#fff"
                                d="M36 16.6c-1 .4-2 .7-3 .8 1.1-.7 2-1.8 2.4-3.1-1 .6-2.1 1-3.2 1.3a5.1 5.1 0 0 0-8.8 4.7c-4.3-.2-8.2-2.3-10.8-5.5a5.1 5.1 0 0 0 1.6 6.8 5.1 5.1 0 0 1-2.3-.6v.1a5.1 5.1 0 0 0 4.1 5 5.1 5.1 0 0 1-2.3.1 5.1 5.1 0 0 0 4.7 3.5 10.2 10.2 0 0 1-6.3 2.2H14a14.5 14.5 0 0 0 7.9 2.3c9.4 0 14.6-7.8 14.6-14.6v-.7c1-.7 1.8-1.6 2.5-2.6z"
                              />
                            </svg>
                          </button>

                          <button
                            className="btn refer-share-icons p-0"
                            onClick={() =>
                              handleShareRefferalUrl(
                                "linkedin",
                                `${process.env.NEXT_PUBLIC_FRONTEND_URL}/?ref=${userDetails?.referral_code}`
                              )
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="40"
                              height="40"
                              viewBox="0 0 48 48"
                            >
                              <path
                                fill="#fff"
                                d="M18 20h4v14h-4V20zm2-6a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zM26 20h3.8v1.9h.1c.5-.9 1.6-1.9 3.3-1.9 3.5 0 4.1 2.3 4.1 5.3V34h-4v-7c0-1.7 0-3.9-2.4-3.9-2.4 0-2.8 1.9-2.8 3.7V34h-4V20z"
                              />
                            </svg>
                          </button>
                          <button
                            className="btn refer-share-icons p-0"
                            onClick={() =>
                              handleShareRefferalUrl(
                                "whatsapp",
                                `${process.env.NEXT_PUBLIC_FRONTEND_URL}/?ref=${userDetails?.referral_code}`
                              )
                            }
                          >
                            <svg
                              className="mx-2"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19.05 4.91005C18.1331 3.98416 17.0411 3.25002 15.8376 2.75042C14.634 2.25081 13.3431 1.99574 12.04 2.00005C6.58005 2.00005 2.13005 6.45005 2.13005 11.9101C2.13005 13.6601 2.59005 15.3601 3.45005 16.8601L2.05005 22.0001L7.30005 20.6201C8.75005 21.4101 10.38 21.8301 12.04 21.8301C17.5 21.8301 21.9501 17.3801 21.9501 11.9201C21.9501 9.27005 20.92 6.78005 19.05 4.91005ZM12.04 20.1501C10.56 20.1501 9.11005 19.7501 7.84005 19.0001L7.54005 18.8201L4.42005 19.6401L5.25005 16.6001L5.05005 16.2901C4.2276 14.9771 3.79097 13.4593 3.79005 11.9101C3.79005 7.37005 7.49005 3.67005 12.03 3.67005C14.23 3.67005 16.3 4.53005 17.85 6.09005C18.6177 6.85392 19.226 7.7626 19.6397 8.76338C20.0534 9.76417 20.2642 10.8371 20.26 11.9201C20.28 16.4601 16.58 20.1501 12.04 20.1501ZM16.56 13.9901C16.31 13.8701 15.09 13.2701 14.87 13.1801C14.64 13.1001 14.48 13.0601 14.31 13.3001C14.14 13.5501 13.67 14.1101 13.53 14.2701C13.39 14.4401 13.24 14.4601 12.99 14.3301C12.74 14.2101 11.94 13.9401 11 13.1001C10.26 12.4401 9.77005 11.6301 9.62005 11.3801C9.48005 11.1301 9.60005 11.0001 9.73005 10.8701C9.84005 10.7601 9.98005 10.5801 10.1 10.4401C10.22 10.3001 10.27 10.1901 10.35 10.0301C10.43 9.86005 10.39 9.72005 10.33 9.60005C10.27 9.48005 9.77005 8.26005 9.57005 7.76005C9.37005 7.28005 9.16005 7.34005 9.01005 7.33005H8.53005C8.36005 7.33005 8.10005 7.39005 7.87005 7.64005C7.65005 7.89005 7.01005 8.49005 7.01005 9.71005C7.01005 10.9301 7.90005 12.1101 8.02005 12.2701C8.14005 12.4401 9.77005 14.9401 12.25 16.0101C12.84 16.2701 13.3 16.4201 13.66 16.5301C14.25 16.7201 14.79 16.6901 15.22 16.6301C15.7 16.5601 16.69 16.0301 16.89 15.4501C17.1 14.8701 17.1 14.3801 17.03 14.2701C16.96 14.1601 16.81 14.1101 16.56 13.9901Z"
                                fill="white"
                              />
                            </svg>
                          </button>

                          <button
                            className="btn p-0"
                            title="Copy Now"
                            onClick={() =>
                              handleShareRefferalUrl(
                                "copy",
                                `${process.env.NEXT_PUBLIC_FRONTEND_URL}/?ref=${userDetails?.referral_code}`
                              )
                            }
                          >
                            <svg
                              width="45"
                              height="45"
                              viewBox="0 0 48 48"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g transform="translate(15 14) scale(0.9)">
                                <path
                                  d="M18 6.94C17.9897 6.84812 17.9695 6.75761 17.94 6.67V6.58C17.893 6.47655 17.8288 6.38186 17.75 6.3L11.75 0.3C11.6681 0.221221 11.5734 0.156968 11.47 0.11C11.4402 0.105474 11.4098 0.105474 11.38 0.11C11.2782 0.0522223 11.1661 0.014858 11.05 0H7C6.20435 0 5.44129 0.316071 4.87868 0.87868C4.31607 1.44129 4 2.20435 4 3V4H3C2.20435 4 1.44129 4.31607 0.87868 4.87868C0.316071 5.44129 0 6.20435 0 7V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H11C11.7956 20 12.5587 19.6839 13.1213 19.1213C13.6839 18.5587 14 17.7956 14 17V16H15C15.7956 16 16.5587 15.6839 17.1213 15.1213C17.6839 14.5587 18 13.7956 18 13V6.94ZM12 3.41L14.59 6H13C12.7348 6 12.4804 5.89464 12.2929 5.70711C12.1054 5.51957 12 5.26522 12 5V3.41ZM12 17C12 17.2652 11.8946 17.5196 11.7071 17.7071C11.5196 17.8946 11.2652 18 11 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V7C2 6.73478 2.10536 6.48043 2.29289 6.29289C2.48043 6.10536 2.73478 6 3 6H4V13C4 13.7956 4.31607 14.5587 4.87868 15.1213C5.44129 15.6839 6.20435 16 7 16H12V17ZM16 13C16 13.2652 15.8946 13.5196 15.7071 13.7071C15.5196 13.8946 15.2652 14 15 14H7C6.73478 14 6.48043 13.8946 6.29289 13.7071C6.10536 13.5196 6 13.2652 6 13V3C6 2.73478 6.10536 2.48043 6.29289 2.29289C6.48043 2.10536 6.73478 2 7 2H10V5C10 5.79565 10.3161 6.55871 10.8787 7.12132C11.4413 7.68393 12.2044 8 13 8H16V13Z"
                                  fill="white"
                                />
                              </g>
                            </svg>
                          </button>
                          {copyReferralUrl && (
                            <div
                              className="position-absolute translate-middle-x bg-dark text-white small px-2 py-1 rounded shadow"
                              style={{ top: "-30px", left: "50%" }}
                            >
                              Copied!
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="mb-3">
                  <button
                    className="w-100 border-0 save-button"
                    onClick={() => setShowCopyPopup(!showCopyPopup)}
                  >
                    Refer
                  </button>
                </div>
              </div>
            </Offcanvas.Body>
          </Offcanvas>

          <Offcanvas
            show={showHelpSupport}
            onHide={toggleHelpSupport}
            placement="end"
            scroll={true}
            backdrop={false}
            className="offcanvas-main border-0"
          >
            <Offcanvas.Header
              closeButton
              className="edit-profile-header d-flex justify-content-between"
            >
              <Button
                className="border-0 bg-white text-dark"
                onClick={toggleHelpSupport}
              >
                <svg
                  width="6"
                  height="11"
                  viewBox="0 0 6 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.99997 1.5C4.99997 1.5 1 4.44593 1 5.5C1 6.55413 5 9.5 5 9.5"
                    stroke="#525252"
                    strokeWidth="1.1875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="ms-2"> Back</span>
              </Button>
              <Offcanvas.Title className="title-head">
                Help & Support
              </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body className="d-flex flex-column h-100">
              <div className="flex-grow-1 overflow-auto">
                {/* <h4 className="earn-head">How can we help you?</h4>
                <p className="why-refer-points">
                  - FAQs
                  <br />
                  - Contact customer support
                  <br />- Learn more about how the app works
                </p> */}
                <div className="bg-light rounded p-3">
                  <p className="mb-2 fw-bold">Email Support</p>
                  <p className="mb-0 text-muted">contact@itsonlyonestop.com</p>
                </div>
                <div className="bg-light rounded p-3 mt-3">
                  <p className="mb-2 fw-bold">Call Us</p>
                  <p className="mb-0 text-muted">+1 (513) 208-0774</p>
                </div>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      )}
      <AddressModal show={show} setShow={setShow} />

      <OrderDetailsModal
        modalShow={orderDetailsModalShow}
        setModalShow={setOrderDetailsModalShow}
      />
    </>
  );
}

export default page;
